// extracted by mini-css-extract-plugin
export var boxItems = "_23-1";
export var boxItemsLg = "_23-2";
export var button = "_23-7";
export var buttonHoverless = "_23-9";
export var buttonLg = "_23-8";
export var filterGroupBox = "_23-0";
export var icon = "_23-3";
export var iconSecondary = "_23-6";
export var iconWrapper = "_23-4";
export var iconWrapperLg = "_23-5";
export var truncatedLabel = "_23-a";